import { ClipboardCheck, Users } from 'lucide-react';
import { Sekce, Radek } from './UzaverkaStranka';
import RadekKolegy, { seraditKolegy } from './RadekKolegy';

/**
 * Rozšířený detail směny — obsah **uvnitř panelu**, než se směna zahájí.
 *
 * Není to samostatná obrazovka, ale rozložená podoba toho, co panel v běžící
 * směně drží zmenšené. Každá část má nahoře svůj protějšek a při zahájení se
 * do něj složí:
 *
 *   Na směně s tebou  →  dlaždice „Kolegové" (vpravo v řádku dlaždic)
 *   Čeká tě N kontrol →  checklist v pracovní ploše — proto odchází dolů
 *
 * Časy tu **vlastní sekci nemají**: stojí pod osou fází (Start · odpočet ·
 * Konec), kam patří. Před zahájením se tam jen zvětší a při složení karty
 * se vrátí do původní velikosti — viz `zvyrazneno` v `OsaFazi`. Vypisovat je
 * podruhé v tabulce by znamenalo totéž dvakrát.
 *
 * Uvolněné místo dostal tým: větší avatary, čitelnější řádek a akce (zpráva,
 * telefon) rovnou tady. Před směnou je to jediné místo, kde je na kolegu vidět
 * celý řádek — v dlaždici se vejde jen kolečko s iniciálami.
 *
 * `Sekce` a `Radek` jsou sdílené s uzávěrkou: je to obyčejná titulkovaná karta
 * a řádek popis/hodnota, jen zatím bydlí v `UzaverkaStranka`.
 */
const sklonujKontroly = (n) => (n === 1 ? '1 kontrola' : n < 5 ? `${n} kontroly` : `${n} kontrol`);

/** Kam a jak část odchází. `origin` míří na její protějšek v panelu. */
const PRECHOD = {
    kontroly: { origin: '50% 100%', konec: 'translateY(26px) scale(0.94)', delay: 0 },
    kolegove: { origin: '88% 0%', konec: 'translateY(-18px) scale(0.32)', delay: 70 },
};

function Slozitelna({ klic, sbaleno, children }) {
    const p = PRECHOD[klic];
    return (
        <div style={{
            transformOrigin: p.origin,
            transform: sbaleno ? p.konec : 'none',
            opacity: sbaleno ? 0 : 1,
            transition: `transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) ${p.delay}ms,`
                + ` opacity 0.2s ease-out ${p.delay}ms`,
        }}>
            {children}
        </div>
    );
}

export default function DetailSmeny({ faze = [], tym = [], sbaleno = false, onZprava, isDark }) {

    // Kolik kontrol je ve které fázi. Nula se nevypisuje — prázdný řádek
    // „0 kontrol" jen říká, že se nic neděje, a bere místo.
    const fazeSKontrolami = (faze || [])
        .map((f) => ({
            id: f.id,
            nazev: f.nazev || f.id,
            pocet: (f.checklisty || []).reduce((s, ch) => s + (ch.total || 0), 0),
        }))
        .filter((f) => f.pocet > 0);

    const celkemKontrol = fazeSKontrolami.reduce((s, f) => s + f.pocet, 0);

    // Manažer první, pak podle jména — stejné pořadí jako v ploše Kolegové.
    const kolegove = seraditKolegy(tym || []);

    return (
        <div style={{
            // Boční odsazení nese panel, tady jen dýchá odshora. Strop na výšku,
            // ať se panel nevytáhne přes celou obrazovku na malém displeji —
            // tlačítko „Začít v X" musí zůstat na očích bez rolování.
            maxHeight: '52vh', overflowY: 'auto', overscrollBehavior: 'contain',
            paddingTop: 2,
            display: 'flex', flexDirection: 'column', gap: 12,
        }}>
            {kolegove.length > 0 && (
                <Slozitelna klic="kolegove" sbaleno={sbaleno}>
                    <Sekce nadpis="Na směně s tebou" barva="#0CC0DF" Ikona={Users} isDark={isDark}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 4 }}>
                            {kolegove.map((k) => (
                                <RadekKolegy key={k.zamestnanec_id ?? k.id ?? `${k.jmeno}-${k.prijmeni}`}
                                    kolega={k} onZprava={onZprava} isDark={isDark} />
                            ))}
                        </div>
                    </Sekce>
                </Slozitelna>
            )}

            {celkemKontrol > 0 && (
                <Slozitelna klic="kontroly" sbaleno={sbaleno}>
                    <Sekce nadpis={`Čeká tě ${sklonujKontroly(celkemKontrol)}`}
                        barva="#FF8A00" Ikona={ClipboardCheck} isDark={isDark}>
                        {fazeSKontrolami.map((f) => (
                            <Radek key={f.id} popis={f.nazev}
                                hodnota={sklonujKontroly(f.pocet)} isDark={isDark} />
                        ))}
                    </Sekce>
                </Slozitelna>
            )}
        </div>
    );
}

